export default {
  id: '3018361',
  name: '1230_h5',
  font_family: 'vant-iconv',
  css_prefix_text: 'h5-',
  description: 'H5图标、web图标',
  glyphs: [
    {
      icon_id: '36190165',
      name: 'steps-error',
      font_class: 'steps-error',
      unicode: 'e628',
      unicode_decimal: 58920,
    },
    {
      icon_id: '36190166',
      name: 'steps-finish',
      font_class: 'steps-finish',
      unicode: 'e629',
      unicode_decimal: 58921,
    },
    {
      icon_id: '36190167',
      name: 'steps-wait',
      font_class: 'steps-wait',
      unicode: 'e62a',
      unicode_decimal: 58922,
    },
    {
      icon_id: '36190168',
      name: 'steps-process',
      font_class: 'steps-process',
      unicode: 'e62b',
      unicode_decimal: 58923,
    },
    {
      icon_id: '33103629',
      name: 'star',
      font_class: 'star1',
      unicode: 'e601',
      unicode_decimal: 58881,
    },
    {
      icon_id: '32399282',
      name: 'loading',
      font_class: 'loading',
      unicode: 'e600',
      unicode_decimal: 58880,
    },
    {
      icon_id: '26584062',
      name: '默认',
      font_class: 'default',
      unicode: 'e608',
      unicode_decimal: 58888,
    },
    {
      icon_id: '26507951',
      name: '左箭头',
      font_class: 'left-arrow',
      unicode: 'e683',
      unicode_decimal: 59011,
    },
    {
      icon_id: '26507949',
      name: '右箭头',
      font_class: 'right-arrow',
      unicode: 'e682',
      unicode_decimal: 59010,
    },
    {
      icon_id: '26507931',
      name: '上箭头',
      font_class: 'top-arrow',
      unicode: 'e681',
      unicode_decimal: 59009,
    },
    {
      icon_id: '26507922',
      name: '下箭头',
      font_class: 'bottom-arrow',
      unicode: 'e680',
      unicode_decimal: 59008,
    },
    {
      icon_id: '26507917',
      name: '关闭',
      font_class: 'close',
      unicode: 'e67f',
      unicode_decimal: 59007,
    },
    {
      icon_id: '26507906',
      name: '添加',
      font_class: 'add',
      unicode: 'e67e',
      unicode_decimal: 59006,
    },
    {
      icon_id: '26507896',
      name: '搜索',
      font_class: 'search',
      unicode: 'e67d',
      unicode_decimal: 59005,
    },
    {
      icon_id: '26507892',
      name: '更多',
      font_class: 'more',
      unicode: 'e67c',
      unicode_decimal: 59004,
    },
    {
      icon_id: '26507888',
      name: '展开',
      font_class: 'unfold',
      unicode: 'e67b',
      unicode_decimal: 59003,
    },
    {
      icon_id: '26507876',
      name: '左三角',
      font_class: 'left-triangle',
      unicode: 'e67a',
      unicode_decimal: 59002,
    },
    {
      icon_id: '26507871',
      name: '右三角',
      font_class: 'right-triangle',
      unicode: 'e679',
      unicode_decimal: 59001,
    },
    {
      icon_id: '26507862',
      name: '上三角',
      font_class: 'top-triangle',
      unicode: 'e678',
      unicode_decimal: 59000,
    },
    {
      icon_id: '26507858',
      name: '下三角',
      font_class: 'bottom-triangle',
      unicode: 'e677',
      unicode_decimal: 58999,
    },
    {
      icon_id: '26507850',
      name: '首页',
      font_class: 'frontpage',
      unicode: 'e676',
      unicode_decimal: 58998,
    },
    {
      icon_id: '26507839',
      name: '我的',
      font_class: 'avatar',
      unicode: 'e675',
      unicode_decimal: 58997,
    },
    {
      icon_id: '26507834',
      name: '聊天',
      font_class: 'chat',
      unicode: 'e674',
      unicode_decimal: 58996,
    },
    {
      icon_id: '26507762',
      name: '购物车',
      font_class: 'cart',
      unicode: 'e673',
      unicode_decimal: 58995,
    },
    {
      icon_id: '26507750',
      name: '客服',
      font_class: 'customer-service',
      unicode: 'e672',
      unicode_decimal: 58994,
    },
    {
      icon_id: '26507741',
      name: '日历',
      font_class: 'calendar',
      unicode: 'e671',
      unicode_decimal: 58993,
    },
    {
      icon_id: '26507468',
      name: '时间',
      font_class: 'time',
      unicode: 'e670',
      unicode_decimal: 58992,
    },
    {
      icon_id: '26507427',
      name: '倒计时',
      font_class: 'countdown',
      unicode: 'e66f',
      unicode_decimal: 58991,
    },
    {
      icon_id: '26507366',
      name: '收藏',
      font_class: 'star',
      unicode: 'e66e',
      unicode_decimal: 58990,
    },
    {
      icon_id: '26507310',
      name: '喜欢',
      font_class: 'like',
      unicode: 'e66d',
      unicode_decimal: 58989,
    },
    {
      icon_id: '26507294',
      name: '通知',
      font_class: 'notice',
      unicode: 'e66c',
      unicode_decimal: 58988,
    },
    {
      icon_id: '26507274',
      name: '确定',
      font_class: 'sure',
      unicode: 'e66b',
      unicode_decimal: 58987,
    },
    {
      icon_id: '26507264',
      name: '提醒',
      font_class: 'info',
      unicode: 'e66a',
      unicode_decimal: 58986,
    },
    {
      icon_id: '26507252',
      name: '帮助',
      font_class: 'help',
      unicode: 'e669',
      unicode_decimal: 58985,
    },
    {
      icon_id: '26507247',
      name: '成功',
      font_class: 'success',
      unicode: 'e668',
      unicode_decimal: 58984,
    },
    {
      icon_id: '26507233',
      name: '失败',
      font_class: 'fail',
      unicode: 'e667',
      unicode_decimal: 58983,
    },
    {
      icon_id: '26507212',
      name: '增加',
      font_class: 'increase',
      unicode: 'e666',
      unicode_decimal: 58982,
    },
    {
      icon_id: '26507104',
      name: '减少',
      font_class: 'decrease',
      unicode: 'e664',
      unicode_decimal: 58980,
    },
    {
      icon_id: '26507098',
      name: '扫一扫',
      font_class: 'scan',
      unicode: 'e663',
      unicode_decimal: 58979,
    },
    {
      icon_id: '26507094',
      name: '联系人',
      font_class: 'contact',
      unicode: 'e662',
      unicode_decimal: 58978,
    },
    {
      icon_id: '26507085',
      name: '密码',
      font_class: 'password',
      unicode: 'e661',
      unicode_decimal: 58977,
    },
    {
      icon_id: '26507079',
      name: '隐藏密码',
      font_class: 'hidden',
      unicode: 'e660',
      unicode_decimal: 58976,
    },
    {
      icon_id: '26507078',
      name: '显示密码',
      font_class: 'visible',
      unicode: 'e65f',
      unicode_decimal: 58975,
    },
    {
      icon_id: '26507077',
      name: 'wifi',
      font_class: 'wifi',
      unicode: 'e65e',
      unicode_decimal: 58974,
    },
    {
      icon_id: '26507071',
      name: '程序',
      font_class: 'program',
      unicode: 'e65d',
      unicode_decimal: 58973,
    },
    {
      icon_id: '26507068',
      name: '图片',
      font_class: 'image',
      unicode: 'e65c',
      unicode_decimal: 58972,
    },
    {
      icon_id: '26507063',
      name: '照片',
      font_class: 'photo',
      unicode: 'e65b',
      unicode_decimal: 58971,
    },
    {
      icon_id: '26506857',
      name: '位置',
      font_class: 'location',
      unicode: 'e65a',
      unicode_decimal: 58970,
    },
    {
      icon_id: '26506845',
      name: '文件',
      font_class: 'file',
      unicode: 'e659',
      unicode_decimal: 58969,
    },
    {
      icon_id: '26506830',
      name: '编辑',
      font_class: 'edit',
      unicode: 'e658',
      unicode_decimal: 58968,
    },
    {
      icon_id: '26506822',
      name: '消息',
      font_class: 'message',
      unicode: 'e657',
      unicode_decimal: 58967,
    },
    {
      icon_id: '26506739',
      name: '下载',
      font_class: 'download',
      unicode: 'e656',
      unicode_decimal: 58966,
    },
    {
      icon_id: '26506726',
      name: '链接',
      font_class: 'link',
      unicode: 'e655',
      unicode_decimal: 58965,
    },
    {
      icon_id: '26506718',
      name: '二维码',
      font_class: 'qrcode',
      unicode: 'e654',
      unicode_decimal: 58964,
    },
  ],
};

